import { ResumeType } from '../../../../types/ResumeTypes';
import ResumeHeadTitle from '../../../common/ResumeHeadTitle';
import BasicInfoViewer from './BasicInfoViewer';
import EducationViewer from './EducationViewer';
import CareerViewer from './CareerViewer';
import ExtraActivityViewer from './ExtraActivityViewer';
import LanguageViewer from './LanguageSkillViewer';
import CertificateViewer from './CertificateViewer';
import AwardViewer from './AwardViewer';

import { useState } from 'react';
import ResumeTabMenu from '../../../common/ResumeTabMenu';
import useMoveScroll from '../../../../hooks/useMoveScroll';

import S from '../Resume.module.scss';
import SelfIntroductionViewer from './SelfIntroductionViewer';
import EtcViewer from './EtcViewer';

interface ViewerProps {
  resume: ResumeType;
  isPreview: boolean;
  changeToEditMode: Function;
  isAdmin: boolean;
}

const Viewer = (props: ViewerProps) => {
  const { isAdmin, resume, isPreview, changeToEditMode } = props;
  const [activeTab, setActiveTab] = useState(0);

  const resumeTabs = {
    0: useMoveScroll('기본 인적사항', 0, setActiveTab),
    1: useMoveScroll('학력 정보', 1, setActiveTab),
    2: useMoveScroll('경력 정보', 2, setActiveTab),
    3: useMoveScroll('외국어/자격증/수상실적', 3, setActiveTab),
    4: useMoveScroll('자기소개서', 4, setActiveTab),
    5: useMoveScroll('기타', 5, setActiveTab),
    length: 6,
  };

  if (resume === undefined) {
    return null;
  }

  return (
    <>
      {/* 뷰어일 때 타이틀 */}
      {!isPreview && (
        <ResumeHeadTitle
          headTitle="이력서"
          resumeType="update"
          resumeHeadAction={changeToEditMode}
        />
      )}
      {/* 어드민이 아닐 때만 탭 노출 */}
      {!isAdmin && <ResumeTabMenu resumeTabs={resumeTabs} activeTab={activeTab} />}

      {/* TODO:: 미리보기일 때 타이틀 노출 */}
      {/* <ResumeHeadTitle headTitle="이력서" resumeType="" /> */}
      <BasicInfoViewer profile={resume.profile} resumeTabs={resumeTabs} />
      <EducationViewer educations={resume.educations} resumeTabs={resumeTabs} />
      <ExtraActivityViewer externalActivities={resume.externalActivities} />
      <CareerViewer careers={resume.careers} resumeTabs={resumeTabs} />
      <LanguageViewer languageSkills={resume.languageSkills} resumeTabs={resumeTabs} />
      <CertificateViewer certifications={resume.qualifications} />
      <AwardViewer awards={resume.awards} />
      <SelfIntroductionViewer resumeTabs={resumeTabs} selfIntroduction={resume.selfIntroduction} />
      <EtcViewer resumeTabs={resumeTabs}
                 militaryServiceInfo={resume.militaryServiceInfo}
                 veteranStatus={resume.veteranStatus}
                 veteranRelation={resume.veteranRelation}
                 disabilityStatus={resume.disabilityStatus}
                 disabilityGrade={resume.disabilityGrade}

      />

      {/* 미리보기 취소 버튼 */}
      {isPreview && !isAdmin && (
        <div className={`${S.edit_mode_submit} wrapper`}>
          <button type="button" className={S.preview_btn} onClick={() => changeToEditMode()}>
            <h3 className="h3">돌아가기</h3>
          </button>
          {/*<button className={S.submit_btn} type="submit" onClick={() => }>*/}
          {/*  <h3 className="h3">완료</h3>*/}
          {/*</button>*/}
        </div>
      )}
    </>
  );
};

export default Viewer;
